import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { createContext, useState } from 'react';
export var DEFAULT_USER_ID = 'no_user_id';
export var UserIdContext = /*#__PURE__*/createContext({
  userId: DEFAULT_USER_ID,
  setUserId: function setUserId() {}
});
export function UserIdProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(DEFAULT_USER_ID),
      _useState2 = _slicedToArray(_useState, 2),
      userId = _useState2[0],
      setUserId = _useState2[1];

  return /*#__PURE__*/React.createElement(UserIdContext.Provider, {
    value: {
      userId: userId,
      setUserId: setUserId
    }
  }, children);
}